import { twMerge } from 'tailwind-merge';
import { Outlet } from 'react-router-dom';
import { PropsWithChildren } from 'react';

import { Background } from 'components';

export default function RootLayout() {
  return (
    <div className="font-manrope flex min-h-screen w-screen">
      <div className="bg-accentGradient-secondary-primary fixed inset-0 z-0"></div>
      <Background className="fixed inset-0 z-[1]" />
      <div className="relative z-10 flex w-full flex-col">
        <Wrapper className="flex min-h-0 flex-1 flex-col py-4 md:py-8">
          <Outlet />
        </Wrapper>
      </div>
    </div>
  );
}

const Wrapper = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => (
  <div
    className={twMerge(
      'w-full px-4 md:px-6 lg:mx-auto lg:max-w-[calc(1280px+(--spacing(12)))]',
      className
    )}
  >
    {children}
  </div>
);
